import { render, staticRenderFns } from "./ArticleDetailPage.vue?vue&type=template&id=62a6401c&scoped=true"
import script from "./ArticleDetailPage.vue?vue&type=script&lang=js"
export * from "./ArticleDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetailPage.vue?vue&type=style&index=0&id=62a6401c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a6401c",
  null
  
)

export default component.exports